import { render, staticRenderFns } from "./ModelHouseEntry.vue?vue&type=template&id=36b9587c&"
import script from "./ModelHouseEntry.vue?vue&type=script&lang=js&"
export * from "./ModelHouseEntry.vue?vue&type=script&lang=js&"
import style0 from "./ModelHouseEntry.vue?vue&type=style&index=0&id=36b9587c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports